<template>
  <section class="deposit" @click="handleClick">
    <div class="deposit__wrapper">
      <div class="deposit__text">
        <p class="deposit__title">¿Tienes arras o reserva?</p>
        <p>Consigue una hipoteca en tiempo récord.</p>
      </div>
      <Button ref="cta" tag="a" :href="route('home.reservation')" :size="size" btn-style="primary">Hipoteca Exprés</Button>
    </div>
  </section>
</template>

<script>
import { onMounted, ref } from '@vue/composition-api';
import { onResize } from '@/lego/utils/window/screen';
import { getTouchedScreen } from '@/lego/utils/tailwind/screen';
import Button from '@/lego/components/buttons/Button.vue';

export default {
  components: { Button },
  setup() {
    const cta = ref(null);
    const screen = ref(null);
    const breakpoints = { xs: 'sm', md: 'lg' };
    const redirect = { xs: true, md: false };
    const size = ref('lg');

    const updateSize = () => {
      screen.value = getTouchedScreen(breakpoints);
      size.value = breakpoints[screen.value];
    };

    const handleClick = () => {
      if (!redirect[screen.value]) {
        return;
      }
      cta.value.click();
    };

    onMounted(() => {
      updateSize();
    });
    onResize(() => {
      updateSize();
    });

    return {
      cta,
      size,
      handleClick,
    };
  },
};
</script>

<style scoped lang="postcss">
.deposit {
  @apply bg-brand-primary-lightest px-xxxs py-nano transition-opacity duration-300 ease-in-out absolute lg:static top-[5.75rem] left-0 right-0 cursor-pointer md:cursor-default z-[5];

  &__wrapper {
    @apply max-w-5xl mx-auto flex flex-col lg:flex-row lg:justify-between md:items-center gap-nano;

    .button {
      @apply w-full md:max-w-[18.5rem] lg:w-auto lg:max-w-none;
    }
  }
  &__text {
    @apply text-center style-overline md:style-body lg:text-left flex flex-col lg:flex-row justify-center items-center lg:items-start lg:gap-nano;
  }
  &__title {
    @apply style-body-sm-bold md:style-subtitle-sm-bold;
  }
}
</style>
